import React from 'react';
import styles from './Pill.module.css';

export enum PillVariant {
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger'
}

interface PillProps {
  variant: PillVariant;
  children: React.ReactNode;
  className?: string;
}

export const Pill: React.FC<PillProps> = ({ variant: pillVariant, children, className = '' }) => {
  const variantClass = styles[pillVariant];

  return (
    <div className={`${styles.pill} ${variantClass} ${className}`}>
      {children}
    </div>
  );
};